import { apiClient } from './apiClient';

class MenuAPI {
  sendMenu(id, params = {}) {
    return apiClient.request(`/menus/${id}/send`, 'POST', true, params);
  }

  searchMenus(params = {}) {
    return apiClient.request(`/menus/search`, 'POST', true, params);
  }

  getMenu(id) {
    return apiClient.request(`/menus/${id}`, 'GET', true);
  }

  getLiveMenus() {
    return apiClient.request(`/menus/live`, 'GET', true);
  }

  // Evergreen
  getEvergreenMenus() {
    return apiClient.request(`/menus/evergreen`, 'GET', true);
  }

  // Company
  getCompanyMenus() {
    return apiClient.request(`/menus/company`, 'GET', true);
  }

  createMenu(menu) {
    return apiClient.request(`/menus`, 'POST', true, menu);
  }

  updateMenu(menu) {
    return apiClient.request(`/menus/${menu.id}`, 'PUT', true, menu);
  }

  deleteMenu(id) {
    return apiClient.request(`/menus/${id}`, 'DELETE', true);
  }

  archiveMenu(id) {
    return apiClient.request(`/menus/${id}/archive`, 'POST', true);
  }

  restoreMenu(id) {
    return apiClient.request(`/menus/${id}/restore`, 'POST', true);
  }

  // GET /dietary_preferences
  getAllergens() {
    return apiClient.request('/allergen_tags', 'GET', true);
  }

  getSeasonality() {
    return apiClient.request(`/seasonality_tags/`, 'GET', true);
  }

  getCuisines() {
    return apiClient.request(`/cuisines/`, 'GET', true);
  }

  getCategories() {
    return apiClient.request(`/dish_categories/`, 'GET', true);
  }

  getDiets() {
    return apiClient.request(`/dietary_preferences/`, 'GET', true);
  }

  createDish(dish) {
    return apiClient.request(`/dishes/`, 'POST', true, dish);
  }

  updateDish(dish) {
    return apiClient.request(`/dishes/${dish.id}`, 'PUT', true, dish);
  }

  getDish(id) {
    return apiClient.request(`/dishes/${id}`, 'GET', true);
  }

  getDishes() {
    return apiClient.request('/dishes', 'GET', true);
  }

  getDishGroceries(params) {
    return apiClient.request('/dishes/calculator ', 'POST', true, params);
  }

  deleteDish(id) {
    return apiClient.request(`/dishes/${id}`, 'DELETE', true);
  }

  forceDeleteMenu(id) {
    return apiClient.request(`/dishes/${id}/force_delete`, 'POST', true);
  }

  searchDishes(params = {}) {
    return apiClient.request(`/dishes/search`, 'POST', true, params);
  }

  getProducts(params = {}) {
    return apiClient.request('/products', 'GET', true, params);
  }

  getProduct(id) {
    return apiClient.request(`/products/${id}`, 'GET', true);
  }

  updateProduct(product) {
    return apiClient.request(`/products/${product.id}`, 'PUT', true, product);
  }

  createProduct(product) {
    return apiClient.request(`/products/`, 'POST', true, product);
  }

  searchProducts(params = {}) {
    return apiClient.request(`/products/search`, 'POST', true, params);
  }

  deleteProduct(id) {
    return apiClient.request(`/products/${id}`, 'DELETE', true);
  }

  getProductCategories() {
    return apiClient.request('/product_categories', 'GET', true);
  }

  getProductFormats() {
    return apiClient.request('/product_formats', 'GET', true);
  }

  getProductUnits() {
    return apiClient.request('/product_units', 'GET', true);
  }

  getProductVendors() {
    return apiClient.request('/product_vendors', 'GET', true);
  }

  // Favoriting Endpoints
  favoriteDish(id) {
    return apiClient.request(`/dishes/${id}/favorite`, 'POST', true);
  }

  unfavoriteDish(id) {
    return apiClient.request(`/dishes/${id}/favorite`, 'DELETE', true);
  }

  async getClientFavorites() {
    let results = await apiClient.paginatedRequest(`/dishes/favorites`, 'GET', true, {}, 'dishes');
    return { dishes: results };
  }
}
export const menuAPI = new MenuAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/menuAPI.js